import { Box, Button, styled, Typography } from '@mui/material';
export const Sidebar = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%', // Full width on mobile
    minWidth: 'auto', // Auto min-width on mobile
    padding: theme.spacing(6, 4),
    gap: theme.spacing(3),
    backgroundColor: `#FAF9F9`, // this colour is not available in design system
    flexGrow: 1, // Takes available space on mobile
    [theme.breakpoints.up('md')]: {
        flex: 1,
        justifyContent: 'flex-start',
        maxWidth: '20rem',
        padding: 0,
        backgroundColor: 'transparent'
    }
}));
export const Logo = styled(Box)(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        marginBottom: theme.spacing(6)
    }
}));
export const Content = styled(Typography)({
    textAlign: 'center',
    width: '100%',
    maxWidth: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap'
});
export const JoinMeetingContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(4)
    }
}));
export const MeetingActionButton = styled(Button)(({ theme }) => ({
    width: '100%',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    '&:disabled': {
        backgroundColor: theme.palette.action.disabledBackground
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29uc3VsdGF0aW9uU2lkZWJhci5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9NZWV0aW5nL01lZXRpbmdWaWRlb0NvbnRhaW5lci9Db25zdWx0YXRpb25TaWRlYmFyLnN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLFVBQVUsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUdoRSxNQUFNLENBQUMsTUFBTSxPQUFPLEdBQWdELE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDOUYsT0FBTyxFQUFFLE1BQU07SUFDZixhQUFhLEVBQUUsUUFBUTtJQUN2QixVQUFVLEVBQUUsUUFBUTtJQUNwQixjQUFjLEVBQUUsUUFBUTtJQUN4QixLQUFLLEVBQUUsTUFBTSxFQUFFLHVCQUF1QjtJQUN0QyxRQUFRLEVBQUUsTUFBTSxFQUFFLDJCQUEyQjtJQUM3QyxPQUFPLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQzVCLEdBQUcsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUNyQixlQUFlLEVBQUUsU0FBUyxFQUFFLGdEQUFnRDtJQUM1RSxRQUFRLEVBQUUsQ0FBQyxFQUFFLGtDQUFrQztJQUMvQyxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsSUFBSSxFQUFFLENBQUM7UUFDUCxjQUFjLEVBQUUsWUFBWTtRQUM1QixRQUFRLEVBQUUsT0FBTztRQUNqQixPQUFPLEVBQUUsQ0FBQztRQUNWLGVBQWUsRUFBRSxhQUFhO0tBQy9CO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFSixNQUFNLENBQUMsTUFBTSxJQUFJLEdBQWdELE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDM0YsT0FBTyxFQUFFLE1BQU07SUFDZixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsT0FBTyxFQUFFLE1BQU07UUFDZixZQUFZLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7S0FDL0I7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVKLE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBdUQsTUFBTSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBQzVGLFNBQVMsRUFBRSxRQUFRO0lBQ25CLEtBQUssRUFBRSxNQUFNO0lBQ2IsUUFBUSxFQUFFLE1BQU07SUFDaEIsU0FBUyxFQUFFLFlBQVk7SUFDdkIsVUFBVSxFQUFFLFVBQVU7Q0FDdkIsQ0FBQyxDQUFDO0FBRUgsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQWdELE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDM0csS0FBSyxFQUFFLE1BQU07SUFDYixDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUU7UUFDNUIsWUFBWSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0tBQy9CO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFSixNQUFNLENBQUMsTUFBTSxtQkFBbUIsR0FBbUQsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNoSCxLQUFLLEVBQUUsTUFBTTtJQUNiLFVBQVUsRUFBRSxNQUFNO0lBQ2xCLFVBQVUsRUFBRSxRQUFRO0lBQ3BCLFlBQVksRUFBRTtRQUNaLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxrQkFBa0I7S0FDekQ7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9